import { useLocation, Link } from "react-router-dom";
import { useSEO } from '../hooks/useSEO';

export default function NotFound() {
  const location = useLocation();

  useSEO({
    title: 'Página no encontrada | Anthony Sánchez Couture',
    description: 'La página que buscas no existe. Vuelve al inicio o explora nuestro atelier de alta costura en Barcelona.',
    noIndex: true,
  });

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 overflow-hidden bg-brand-cream">
      {/* Decorative background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/3 w-[600px] h-[600px] rounded-full bg-brand-gray-100/50 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] rounded-full bg-brand-sage/8 blur-2xl" />
      </div>

      {/* Large watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <span className="text-[10rem] md:text-[14rem] font-black text-brand-gray-200/30 tracking-tighter">
          404
        </span>
      </div>

      <div className="relative z-10 max-w-lg w-full">
        {/* Icon */}
        <div className="w-16 h-16 rounded-full bg-brand-black flex items-center justify-center text-white mx-auto">
          <i className="ri-search-line text-2xl" />
        </div>

        <h1 className="font-serif text-brand-black text-3xl md:text-4xl font-medium mt-8 leading-tight">
          Página no encontrada
        </h1>

        <p className="font-sans text-brand-gray-500 text-sm mt-3 font-mono">
          {location.pathname}
        </p>

        <p className="font-sans text-brand-gray-600 text-base md:text-lg mt-4 leading-relaxed max-w-md mx-auto">
          La página que buscas no existe o ha sido movida. Te invitamos a explorar el atelier desde el inicio.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-brand-black text-white font-sans text-sm tracking-widest uppercase px-8 py-3.5 rounded-full hover:bg-brand-gray-800 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line" />
            Volver al inicio
          </Link>
          <Link
            to="/contacto"
            className="inline-flex items-center gap-2 border border-brand-gray-300 text-brand-black font-sans text-sm tracking-widest uppercase px-8 py-3.5 rounded-full hover:border-brand-black hover:bg-white transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-line" />
            Contactar
          </Link>
        </div>

        {/* Quick links */}
        <div className="mt-12 pt-8 border-t border-brand-gray-200">
          <p className="font-sans text-brand-gray-400 text-xs uppercase tracking-[0.2em] mb-4">
            Explora el atelier
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {[
              { label: 'Alta Costura', path: '/alta-costura' },
              { label: 'Vestidos de Novia', path: '/vestidos-novia' },
              { label: 'Asesoría', path: '/asesoria-imagen' },
              { label: 'Tienda', path: '/tienda' },
              { label: 'Blog', path: '/blog' },
            ].map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="px-4 py-2 rounded-full bg-brand-gray-50 font-sans text-brand-gray-600 text-sm hover:bg-brand-gray-100 hover:text-brand-black transition-colors whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}